import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useNotice } from '../../state/NoticeContext.jsx';
import { authApi } from '../../api/endpoints.js';
import { Button, Card, Text } from '../../ui.jsx';

export default function ForgotPassword() {
  const notice = useNotice();
  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (event) => {
    event.preventDefault();
    setBusy(true);
    try {
      const data = await authApi.forgotPassword(email.trim());
      notice.success(data.message);
      setSent(true);
    } catch (error) {
      notice.fromError(error);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="authw">
      <Card>
        <h1 style={{ fontSize: 24, marginBottom: 4 }}>Reset your password</h1>
        <p className="mu" style={{ marginBottom: 16 }}>
          Enter your email address and we will send you a reset code.
        </p>
        {sent ? (
          <>
            <div className="note">
              If that address has an account, a reset code is on its way. The code is also required to
              sign out every other device.
            </div>
            <Link to="/reset-password" className="btn" style={{ textDecoration: 'none', display: 'block' }}>
              Enter the code
            </Link>
          </>
        ) : (
          <form onSubmit={submit}>
            <Text
              label="Email"
              type="email"
              required
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <div style={{ height: 16 }} />
            <Button type="submit" busy={busy} style={{ width: '100%' }}>Send reset code</Button>
          </form>
        )}
        <p className="mu" style={{ marginTop: 16, textAlign: 'center' }}>
          <Link to="/signin">Back to log in</Link>
        </p>
      </Card>
    </div>
  );
}
